export enum FillerStatus {
  AVAILABLE = "Доступно",
  INORDER = "Заказ",
  UNAVAILABLE = "Недоступно",
}

export interface IFiller {
  _id: string;
  date: string;
  lastUpdate: string;
  name: string;
  quantity: number;
  description: string;
  machineId: string;
  machineName: string;
  ownerId: string;
  ownerName: string;
  status: FillerStatus;
}
